import { Bar, mixins } from 'vue-chartjs'

export default Bar.extend({
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, {
      legend: {
        display: true,
        position: 'top'
      },
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }],
        xAxes: [{
          gridLines: {
            display: false
          },
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }]
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/graficos/GraficoBarra.js